import {
    Color, DisplayObject,
} from '@tencent/alloy-renderer';
import { IFrame } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-graphic/graphic-component.interface';
import { getFrameAfterRotate } from '@src/slide/infrastructure/module/independent/graphic';
import TableModel from '@src/slide/domain/ui-model/element-modeles/table-model';
import { color2HexAndAlpha } from '@src/slide/infrastructure/module/independent/color/transform';

/**
 * 3d 渲染组件和 alloy-renderer 的 filter 渲染机制有冲突，共存时会导致渲染卡顿，具体原因待深入研究。
 * 考虑到共用两种属性的用户较少，目前暂时采取对于 3d 渲染组件屏蔽掉所有 filter 的形式优化性能
 */
export function ignoreRendererFiltersFor3dDisplayObject(displayObject?: DisplayObject) {
    if (displayObject) {
        (displayObject as any).filters.length = 0;
    }
}

export function getFillColor(srgb: string | undefined): Color | null {
    if (srgb === 'none' || !srgb) {
        return null;
    }
    const colorObj = color2HexAndAlpha(srgb);
    return Color.fromHex(`#${colorObj.colorValue}`, colorObj.alpha);
}

function safeValue(value, defaultValue) {
    return (value ? value : defaultValue);
}

function getImageRect(image, width, height, outerWidth, outerHeight) {
    let pl = 0;
    let pt = 0;
    let pr = 0;
    let pb = 0;

    if (typeof image.width !== 'undefined') {     // /说明是前景图
        width = image.width;
        height = image.height;
        pl = parseInt(image.pl, 10);
        pt = parseInt(image.pt, 10);
    } else if (image.stretch) {   // /说明是背景图
        if (image.stretch.srcRect) {
            pl = width * safeValue(image.stretch.srcRect.l, 0);
            pr = width * safeValue(image.stretch.srcRect.r, 0);
            pt = height * safeValue(image.stretch.srcRect.t, 0);
            pb = height * safeValue(image.stretch.srcRect.b, 0);
        } else if (image.stretch.fillRect) {
            pl = width * safeValue(image.stretch.fillRect.l, 0);
            pr = width * safeValue(image.stretch.fillRect.r, 0);
            pt = height * safeValue(image.stretch.fillRect.t, 0);
            pb = height * safeValue(image.stretch.fillRect.b, 0);
        }

        width = width + pl + pr;
        height = height + pt + pb;
        if (isNaN(width)) width = outerWidth;
        if (isNaN(height)) height = outerHeight;
        pl = -pl;
        pt = -pt;
    }
    return { pl, pt, width, height };
}

export function getImageFrame(imageFill, bgOption): IFrame {
    const { width: frameWidth, height: frameHeight } = bgOption;
    const outerWidth = frameWidth;
    const outerHeight = frameHeight;
    const { pl, pt, width, height } = getImageRect(imageFill, frameWidth, frameHeight, outerWidth, outerHeight);

    let imgW = Math.round(width); // 图片大小取整，否则会非常模糊
    let imgH = Math.round(height);

    let imgLeft = Math.round(pl);
    let imgTop = Math.round(pt);

    const hasRotateWithShape = typeof (imageFill.rotWithShape) !== 'undefined';
    const notRotateWithShape = hasRotateWithShape && imageFill.rotWithShape === 0; // 不随形状旋转
    let rotate = 0;
    if (notRotateWithShape && !imageFill.isForeground) {
        rotate = bgOption.rotate;
        rotate = 360 - (rotate % 360);

        // @ts-ignore
        const newRect: IFrame = getFrameAfterRotate({
            top: 0, left: 0, width: imgW, height: imgH,
        }, 360 - rotate);
        imgW = newRect.width;
        imgH = newRect.height;
        imgLeft = imgLeft + newRect.left;
        imgTop = imgTop + newRect.top;
    }

    return {
        width: imgW,
        height: imgH,
        left: imgLeft,
        top: imgTop,
        rotate,
    };
}

export function getEditorInstanceByModel(model) {
    let editorInstance: any = null;

    if (model instanceof TableModel as any) {
        const row = model?.selectedRange?.rowStart;
        const col = model?.selectedRange?.colStart;
        const editorModel = model.tableItems[row]?.[col];
        editorInstance = editorModel?.editorInstance;
    } else {
        editorInstance = model && (model.editorInstance || model.noteInstance?.editorInstance
            || model.noteInstance?.textEditor);
    }

    return editorInstance;
}
